import React from "react";
import ContactForm from "./contactform.js";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaRegCommentDots, FaMapPin, FaRegHourglass } from "react-icons/fa"; // Exemplo de ícones de FontAwesome
import "./Module2.css";
import "./styles.css";
import { useEffect, useState } from "react";
import CalendlyButton from './components/CalendlyButton';

const Module9 = () => {

function ResponsiveTitle() {
  const [isMobile, setIsMobile] = useState(false);

  // Função que altera o estado dependendo do tamanho da tela
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Muda para "mobile" se a largura for menor ou igual a 768px
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Chama no início para ajustar o estado baseado na largura da tela

    return () => window.removeEventListener('resize', handleResize); // Limpeza do evento
  }, []);

  return isMobile ? (
    <h4 className="text-center fw-bold special-font" style={{ letterSpacing: '5px', lineHeight: '26px' }}>
      E AGORA? <p className=""></p>O QUE VOCÊ VAI ESCOLHER? 
    </h4>
  ) : (
    <h3 className="text-center fw-bold special-font" style={{ letterSpacing: '8px', lineHeight: '22px' }}>
      E AGORA? <p className=""></p>O QUE VOCÊ VAI ESCOLHER? 
    </h3>
  );
}

  return (
    <div className="bg-white ">
      <div className="p-5 container-sm">
        <ResponsiveTitle />

       
       

        <p className=" text-start mt-5 " style={{ fontSize: "18px", color: "#676767", letterSpacing: "1.8px" }}>
          
          <span className="fw-bold">Você pode continuar sonhando com uma vida em um novo patamar</span> – mas sem
          nunca dar o passo que realmente te leva até lá.
        </p>
        <p className=" text-start mt-4" style={{ fontSize: "18px", color: "#676767", letterSpacing: "1.8px" }}>
          
        <span className="fw-bold">Pode passar anos investindo sem estratégia,</span> ouvindo apenas assessores
          que querem que invista em projetos onde eles são remunerados por isso,
          apenas para ver seu patrimônio corroer bem na hora que mais precisar.
        </p>
        <p className=" text-start mt-4" style={{ fontSize: "18px", color: "#676767", letterSpacing: "1.8px" }}>
          
          <span className="fw-bold"> Pode deixar que o tempo passe</span> e, no futuro, olhar para trás e perceber
          que perdeu oportunidades valiosas.
        </p>
        <p
          className=" text-center mt-5 special-font"
          style={{ fontSize: "18px", color: "black", letterSpacing: "1.8px" }}
        >
          Ou você pode{" "}
          <span className="fw-bold">
            {" "}
            agir agora, fazer parte do grupo seleto de investidores pioneiros da
            IMO
          </span>{" "}
          e garantir condições{" "}
          <span className="fw-bold">
            {" "}
            que nunca mais serão oferecidas a novos investidores.
          </span>
        </p>
        <p className=" text-start mt-5 " style={{ fontSize: "18px", color: "#676767", letterSpacing: "1.8px" }}>
          
          <span className="fw-bold">
            {" "}
            Se você entrar agora, 
          </span>{" "}
          terá prioridade nas melhores oportunidades,{" "}
          <span className="fw-bold">
            {" "}
            rentabilidade elevada, isenção vitalícia da Taxa de Gestão
            Estratégica e benefícios fiscais exclusivos.
          </span>{" "}
        </p>
        <br></br>
        <p className=" text-start" style={{ fontSize: "18px", color: "black", letterSpacing: "1.8px" }}>
          O que
          você escolhe:
          <span className="fw-bold">
            {" "}
            esperar e correr o risco de nunca atingir o próximo nível ou tomar a
            decisão certa agora e construir o futuro que sempre quis?
          </span>
        </p>
        
      </div>
     
       {/* <div className="d-flex justify-content-center align-items-center">


  <button
    className="btn border-0 mb-2 mt-2 px-5 py-3 fw-bold"
    style={{
      backgroundColor: "#ECA600",
      letterSpacing: "1.8px",
      borderRadius: "50px",
      fontSize: "1rem",
      color: "black",
      transition: "all 0.3s ease",
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = "#f0b000";
      e.target.style.color = "#fff";
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = "#ECA600";
      e.target.style.color = "black";
    }}
  >
    QUERO ELEVAR MEUS INVESTIMENTOS AGORA
  </button>
</div> */}
        <div className="">
        
        <CalendlyButton label="QUERO ELEVAR MEUS INVESTIMENTOS AGORA" />
      </div>
 <p
  className="container text-center text-white"
  style={{
    fontSize: "26px", // Aumentei um pouco
    fontWeight: "bold", // Negrito
    letterSpacing: "1.5px",
    paddingTop: "20px",
    paddingBottom: "20px",
    borderTop: "2px solid #ECA600", // Linha separadora em cima
    marginTop: "50px", // Maior respiro antes
  }}
></p>
      <div className="p-1">
        <ContactForm />
      </div>
    </div>
  );
};

export default Module9;
